<ng-container [ngSwitch]="actionType">
  <!-- add-n-remove -->
  <ng-container *ngSwitchCase="'add-n-remove'">
    <ng-container *ngTemplateOutlet="addRemoveTemplate"></ng-container>
  </ng-container>

  <!-- single-button -->

  <ng-container *ngSwitchCase="'single-button'">
    <ng-container *ngIf="rowIndex === controlLength - 1">
      <div *ngIf="showDivider" class="mx-4 ml-0 my-4 border-t-2 w-full">
        <mat-divider></mat-divider>
      </div>
      <div class="mr-3 text-right mb-3">
        <button type="button" mat-flat-button class="w-auto button-primary inline-flex gap-1" (click)="add.emit()">
          <mat-icon matSuffix class="material-icons-outlined !m-0 order-last"> add </mat-icon>
          <span>Add {{ selectedBuyoutRightsType?.toLowerCase() }}</span>
        </button>
      </div>
    </ng-container>
  </ng-container>

  <!-- default -->
  <ng-container *ngSwitchDefault>
    <ng-container *ngIf="fieldName !== 'buyoutRightsFormArray'">
      <ng-container *ngTemplateOutlet="addRemoveTemplate"></ng-container>
    </ng-container>
  </ng-container>
</ng-container>

<ng-template #addRemoveTemplate>
  <div class="action-icons flex items-center gap-2" [ngClass]="getDynamicClasses()">
    <button mat-icon-button class="button-icon-primary" [disabled]="controlLength === 1" (click)="remove.emit()">
      <mat-icon>delete_outline</mat-icon>
    </button>
    <button [ngClass]="{ invisible: !isLastIndex() }" mat-icon-button class="button-icon-primary !inline-flex button-add-entry" [disabled]="!canAdd()" (click)="add.emit()">
      <mat-icon>add</mat-icon>
    </button>
  </div>
</ng-template>
